// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

function handleChange(event) {

    this.onProductPinChange(event.target.value);

}

function handleReset() {

    this.onCriteriaReset();

}

const PinCrossReferenceCriteria = props =>
    <div className='pin-cross-reference-criteria'>
        <div className='criteria-container'>
            <LabeledCriteria
                className='pin-criteria'
                isRequired={true}
                label='PIN'
                maxLength='17'
                onInputChange={props::handleChange}
                placeholder='PIN'
                type='text'
                value={props.criteria.pin}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props::handleReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreatePinCrossReferenceReport}
            showExport={false}
            showReport={true}
        />
    </div>;

PinCrossReferenceCriteria.displayName = 'PinCrossReferenceCriteria';
PinCrossReferenceCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    onCreatePinCrossReferenceReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onProductPinChange: PropTypes.func.isRequired
};

export default PinCrossReferenceCriteria;



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/components/pin-cross-reference-report-criteria.js